import { API_BASE_URL } from 'src/globals';

import { POST, GET } from './apiHandler';
import {
  RATE_DIGITISATION,
  RATE_DIGITISATION_DISCOVER_RATES_SEARCH,
  RATE_DIGITISATION_DISCOVER_RATES_GET_FILTERS,
  DISCOVER_RATES_BUY_REPORT_ISSUE,
  DISCOVER_RATES_SELL_REPORT_ISSUE,
  DISCOVER_RATES_FETCH_SELL_RATES,
  CREATE_BOOKING_DATA,
  DISCOVER_RATES_SAVE_GRID_SEARCH_HISTORY,
  DISCOVER_RATES_FETCH_RECENT_SEARCHES,
  DISCOVER_RATES_FETCH_TRENDING_SEARCHES,
  DISCOVER_RATES,
  DOWNLOAD_QUOTATION_PDF,
  DISCOVER_RATES_SEND_EMAIL,
  DISCOVER_RATES_FETCH_SEARCH_BAR_FILTERS,
} from './routes';

export const rateDigitisationDiscoverRates = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DISCOVER_RATES_SEARCH}`,
    body
  );
};

export const rateDigitisationDiscoverRatesGetFilters = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${RATE_DIGITISATION_DISCOVER_RATES_GET_FILTERS}`,
    body
  );
};

export const discoverRatesReportIssue = async (body, view) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${
      view === 'BUY' ? DISCOVER_RATES_BUY_REPORT_ISSUE : DISCOVER_RATES_SELL_REPORT_ISSUE
    }`,
    body
  );
};

export const fetchDiscoverSellRates = async (body) => {
  return POST(`${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES_FETCH_SELL_RATES}`, body);
};

export const createBookingData = async (body) => {
  return POST(`${API_BASE_URL}${CREATE_BOOKING_DATA}`, body);
};

export const saveGridSearchHistory = async (body) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES_SAVE_GRID_SEARCH_HISTORY}`,
    body
  );
};

export const fetchRecentSearches = async (params) => {
  return GET(`${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES_FETCH_RECENT_SEARCHES}`, params);
};

export const fetchTrendingSearches = async (params) => {
  return GET(`${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES_FETCH_TRENDING_SEARCHES}`, params);
};

export const downloadQuotations = async (body, view) => {
  return POST(
    `${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES}/${view.toLowerCase()}${DOWNLOAD_QUOTATION_PDF}`,
    body,
    undefined,
    true
  );
};

export const shareRateData = async (body) => {
  return POST(`${API_BASE_URL}${DISCOVER_RATES_SEND_EMAIL}`, body);
};


export const fetchModeBasedSearchFilters = async (body) => {
  return GET(`${API_BASE_URL}${RATE_DIGITISATION}${DISCOVER_RATES_FETCH_SEARCH_BAR_FILTERS}`, body);
}